<template>
    <div class="overflow-x-auto">
        <table class="w-full table-auto border-separate border-spacing-y-2">
            <tbody>
                <tr v-for="(order, index) in orders" :key="`order-${index}`">
                    <td class="table-cell">
                        <img :src="order.company_logo" alt="logo" class="w-12" />
                    </td>
                    <td class="table-cell">
                        <span class="truncate whitespace-nowrap font-semibold text-primary">{{
                            order.campaign_name
                        }}</span>
                    </td>
                    <td class="table-cell">
                        {{ moment(order.created_on).format('DD.MM.YYYY') }}
                    </td>
                    <td class="table-cell">
                        <p class="whitespace-nowrap">
                            <span class="text-primary">{{ $t('portfolio.orders.order_status') }}:</span>&nbsp;
                            <span :class="getOrderStatusColor(order.status)">
                                {{
                                    $t(`portfolio.orders.order_status_${OrderStatus[order.status].toLocaleLowerCase()}`)
                                }}</span
                            >
                        </p>
                    </td>
                    <td class="table-cell">
                        <span class="whitespace-nowrap text-primary">{{
                            formatCurrency(order.total_amount, order.currency ?? 'EUR')
                        }}</span>
                    </td>
                    <td v-if="order.order_uid" class="table-cell">
                        <a
                            :href="`/order/#${order.order_uid}`"
                            class="block flex h-6 w-6 items-center justify-center rounded-md bg-gray-200 hover:bg-gray-300"
                            ><EyeIcon class="h-5 w-5 text-primary"
                        /></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
import moment from 'moment'
import { EyeIcon } from '@heroicons/vue/outline'
import { defineProps } from 'vue'
import { OrdersListItem } from '../../../typings'
import { OrderStatus } from '../../../typings/enums'
import { formatCurrency } from '../../../utilities/helpers'

defineProps<{
    orders: OrdersListItem[]
}>()

function getOrderStatusColor(status: number) {
    if (status === OrderStatus['order_status_canceled']) {
        return 'text-gray-400'
    }
    return 'text-green-600'
}
</script>

<style scoped>
.table-cell {
    @apply border-y border-gray-300 bg-white px-4 py-6 first:rounded-l-lg first:border-l last:sticky last:right-0 last:rounded-r-lg last:border-r;
}
</style>
